import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {deletePurchase, fetchPurchase, fetchVendorPurchase} from "../../store/purchase-slice";
import {useSearchParams} from "react-router-dom";
import Table from "../../components/common/table/Table";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {resetCreateStatus, resetUpdateStatus, resetDeleteStatus} from "../../store/purchase-slice";
import {getTableColumns, getTableData} from "../../models/purchaseModel";
import {fetchVendorList} from "../../store/list-slice";

const PurchaseView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [filterByVendor, setFilterByVendor] = useState();
    const [filterByDate, setFilterByDate] = useState();
    const list = useSelector(state => state.list);
    const {items: vendors} = list.vendor;
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        deleteStatus,
        pagination,
        error
    } = useSelector((state) => state.purchase);

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;


    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (deleteStatus === "success") {
            dispatch(resetDeleteStatus());
        }
    }, [dispatch, deleteStatus]);

    const handleProductChangeFilter = (e) => {
        setFilterByVendor(e.target.value);
    }

    const deleteHandler = (id) => {
        dispatch(deletePurchase({...userRole, id}));
    };

    useEffect(() => {
        const basePayload = {
            ...userRole,
            page: initialPage,
            limit: initialLimit,
            ...(filterByDate && {date: filterByDate})
        };

        if (filterByVendor) {
            dispatch(fetchVendorPurchase({...basePayload, id: filterByVendor}));
        } else {
            dispatch(fetchPurchase(basePayload));
        }
    }, [dispatch, filterByVendor, filterByDate, userRole, initialPage, initialLimit]);

    useEffect(() => {
        dispatch(fetchPurchase({...userRole, page: initialPage, limit: initialLimit}));
        dispatch(fetchVendorList(userRole));
    }, [dispatch, initialPage, initialLimit, userRole])

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Purchases">
                {fetchStatus === "success" && <><select
                    className="form-select form-select-sm"
                    name="vendorFilter"
                    onChange={handleProductChangeFilter}
                >
                    <option value="">Select Vendor</option>
                    {Object.entries(vendors).map(([id, name]) => (
                        <option key={id} value={id}>
                            {name}
                        </option>
                    ))}
                </select>
                    <input
                        className="form-control form-control-sm"
                        name="startDate"
                        type="date"
                        value={filterByDate}
                        onChange={(e) => setFilterByDate(e.target.value)}
                    />
                </>
                }
                <Button to="add" className="btn-sm bg-primary bg-opacity-50 text-nowrap">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <>
                    <Table
                        className="mobile-responsive"
                        columns={tableColumns}
                        data={tableData}
                        pagination={pagination}
                    />
                </>
            )}
        </>
    )
}
export default PurchaseView;
